// Author panyurou
// Date 2023-11-23 20:44:09

class SithMesStoolPurchasingGroup {
constructor({
        id = null,
        code = '',
        userId = '',
        remark = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.userId = userId;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesStoolPurchasingGroup();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.stool.sithMesStoolPurchasingGroup.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'code',
        label: 'label.sith.stool.sithMesStoolPurchasingGroup.grid.code',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'userName',
        label: 'label.sith.stool.sithMesStoolPurchasingGroup.grid.userName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'userLoginName',
        label: 'label.sith.stool.sithMesStoolPurchasingGroup.grid.userLoginName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolPurchasingGroup.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    codeFilter : '',
    userIdFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.sith.stool.sithMesStoolPurchasingGroup.filter.code',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'userIdFilter',
        label: 'label.sith.stool.sithMesStoolPurchasingGroup.filter.userId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'id'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.sith.stool.sithMesStoolPurchasingGroup.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'userId',
        label: 'label.sith.stool.sithMesStoolPurchasingGroup.entity.userId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolPurchasingGroup.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesStoolPurchasingGroup, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
